import axiosInstance from "@/api/axiosInstance";
import type { Builder } from "@/types/user";
import { type AxiosInstance } from "axios";

const api: AxiosInstance = axiosInstance;

export const authApi = {
  async checkEmail(data) {
    return await api.post("/check-email", data);
  },

  async getSocialRedirect(provider: string): Promise<string> {
    const response = await api.get(`/auth/${provider}/redirect`);
    return response.data.redirect;
  },
  async socialCallback(provider: string, queryString: string, data) {
    return await api.post(`/auth/${provider}/callback${queryString}`, data);
  },

  async login(data) {
    return await api.post("/login", data);
  },
  async forgot(data) {
    return await api.post("/forgot-password", data);
  },
  async resendPasswordLink(data) {
    return await api.post("/resend-password-link", data);
  },
  async reset(data) {
    return await api.post("/reset-password", data);
  },

  async register(data) {
    return await api.post("/register", data);
  },

  async registerBuilder(data: FormData): Promise<Builder | null> {
    const response = await api.post("/register-builder", data);
    return response.data.data ? response.data.data : null;
  },

  async emailVerify(id: string, hash: string, query: Record<string, string>) {
    const queryString = new URLSearchParams(query).toString();
    const response = await api.get(`/email/verify/${id}/${hash}?${queryString}`);
    return response.data;
  },

  async logout() {
    const response = await api.post("/logout");
    return response.status;
  },

  async fetchUser() {
    return await api.get("/user");
  },
};
